import { api } from '@api'
import type { Event } from '@hvf/contracts'
import { userId } from '@state/auth'
import { useQuery } from '@tanstack/solid-query'

const getEvents = async (): Promise<Event[]> => {
	const { data, error } = await api()
		.from('events')
		.select('*')
		.order('starts_at', { ascending: true })

	if (error) throw new Error(error.message)
	return data || []
}

export function useEvents() {
	const events = useQuery(() => ({
		queryKey: ['events', userId()],
		queryFn: getEvents,
		// Keep data fresh for 5 minutes, but keep in cache for 30
		staleTime: 1000 * 60 * 5,
	}))

	return {
		events,
	}
}
